// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos personalizados para Select2 */

/* Contenedor principal del Select2 */
.select2-container .select2-selection--single {
  height: auto !important;
  min-height: 4vh !important;
  padding: 1.8vh 1.2vh !important;
  border-radius: 1.5vh !important;
  border: 2px solid var(--gray200, #e5e7eb) !important;
  background-color: white !important;
  font-size: 1.8vh !important;
  font-family: 'Inter', sans-serif !important;
  transition: all 0.3s ease !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Hover state */
.select2-container .select2-selection--single:hover {
  border-color: var(--primary, #3b82f6) !important;
}

/* Focus state */
.select2-container.select2-container--focus .select2-selection--single {
  border-color: var(--primary, #3b82f6) !important;
  box-shadow: 0 0 0 0.2vh rgba(59, 130, 246, 0.2) !important;
}

/* Flecha del Select2 */
.select2-container .select2-selection__arrow {
  height: 100% !important;
  top: 50% !important;
  right: 1vh !important;
  transform: translateY(-50%) !important;
}

.select2-container .select2-selection__arrow b {
  border-color: var(--gray400, #9ca3af) transparent transparent transparent !important;
  border-width: 0.5vh 0.4vh 0 0.4vh !important;
  margin-left: -0.4vh !important;
  margin-top: -0.2vh !important;
}

/* Dropdown del Select2 */
.select2-container .select2-dropdown {
  border-radius: 1.2vh !important;
  border: 2px solid var(--gray200, #e5e7eb) !important;
  background-color: white !important;
  box-shadow: 0 0.4vh 1.2vh rgba(0, 0, 0, 0.1) !important;
  margin-top: 0.5vh !important;
}

/* Opciones del dropdown */
.select2-container .select2-results__option {
  padding: 1.2vh 1.6vh !important;
  font-size: 1.8vh !important;
  font-family: 'Inter', sans-serif !important;
  color: var(--gray700, #374151) !important;
  border-radius: 0.4vh !important;
  margin: 0.2vh 0.4vh !important;
}

/* Opción hover */
.select2-container .select2-results__option--highlighted {
  background-color: var(--primary, #3b82f6) !important;
  color: white !important;
}

/* Opción seleccionada */
.select2-container .select2-results__option--selected {
  background-color: var(--primary, #3b82f6) !important;
  color: white !important;
}

/* Placeholder */
.select2-container .select2-selection__placeholder {
  color: var(--gray500, #6b7280) !important;
  font-style: normal !important;
}

/* Texto seleccionado */
.select2-container .select2-selection__rendered {
  color: var(--gray700, #374151) !important;
  line-height: 1.4 !important;
  padding-left: 0 !important;
  padding-right: 2vh !important;
}

/* Search box en el dropdown */
.select2-container .select2-search--dropdown {
  padding: 1vh !important;
}

.select2-container .select2-search__field {
  border-radius: 0.8vh !important;
  border: 1px solid var(--gray300, #d1d5db) !important;
  padding: 0.8vh !important;
  font-size: 1.6vh !important;
  font-family: 'Inter', sans-serif !important;
  outline: none !important;
}

.select2-container .select2-search__field:focus {
  border-color: var(--primary, #3b82f6) !important;
  box-shadow: 0 0 0 0.1vh rgba(59, 130, 246, 0.2) !important;
}

/* Asegurar que el contenedor no tenga estilos por defecto */
.select2-container {
  display: block !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/select2Custom.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,qCAAqC;AACrC;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,oDAAoD;EACpD,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,gDAAgD;AAClD;;AAEA,gBAAgB;AAChB;EACE,gDAAgD;EAChD,0DAA0D;AAC5D;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,oFAAoF;EACpF,4CAA4C;EAC5C,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,oDAAoD;EACpD,kCAAkC;EAClC,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,2CAA2C;EAC3C,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,oDAAoD;EACpD,yBAAyB;EACzB,2BAA2B;EAC3B,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;EAChD,0DAA0D;AAC5D;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;AAC7B","sourcesContent":["/* Estilos personalizados para Select2 */\r\n\r\n/* Contenedor principal del Select2 */\r\n.select2-container .select2-selection--single {\r\n  height: auto !important;\r\n  min-height: 4vh !important;\r\n  padding: 1.8vh 1.2vh !important;\r\n  border-radius: 1.5vh !important;\r\n  border: 2px solid var(--gray200, #e5e7eb) !important;\r\n  background-color: white !important;\r\n  font-size: 1.8vh !important;\r\n  font-family: 'Inter', sans-serif !important;\r\n  transition: all 0.3s ease !important;\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n/* Hover state */\r\n.select2-container .select2-selection--single:hover {\r\n  border-color: var(--primary, #3b82f6) !important;\r\n}\r\n\r\n/* Focus state */\r\n.select2-container.select2-container--focus .select2-selection--single {\r\n  border-color: var(--primary, #3b82f6) !important;\r\n  box-shadow: 0 0 0 0.2vh rgba(59, 130, 246, 0.2) !important;\r\n}\r\n\r\n/* Flecha del Select2 */\r\n.select2-container .select2-selection__arrow {\r\n  height: 100% !important;\r\n  top: 50% !important;\r\n  right: 1vh !important;\r\n  transform: translateY(-50%) !important;\r\n}\r\n\r\n.select2-container .select2-selection__arrow b {\r\n  border-color: var(--gray400, #9ca3af) transparent transparent transparent !important;\r\n  border-width: 0.5vh 0.4vh 0 0.4vh !important;\r\n  margin-left: -0.4vh !important;\r\n  margin-top: -0.2vh !important;\r\n}\r\n\r\n/* Dropdown del Select2 */\r\n.select2-container .select2-dropdown {\r\n  border-radius: 1.2vh !important;\r\n  border: 2px solid var(--gray200, #e5e7eb) !important;\r\n  background-color: white !important;\r\n  box-shadow: 0 0.4vh 1.2vh rgba(0, 0, 0, 0.1) !important;\r\n  margin-top: 0.5vh !important;\r\n}\r\n\r\n/* Opciones del dropdown */\r\n.select2-container .select2-results__option {\r\n  padding: 1.2vh 1.6vh !important;\r\n  font-size: 1.8vh !important;\r\n  font-family: 'Inter', sans-serif !important;\r\n  color: var(--gray700, #374151) !important;\r\n  border-radius: 0.4vh !important;\r\n  margin: 0.2vh 0.4vh !important;\r\n}\r\n\r\n/* Opción hover */\r\n.select2-container .select2-results__option--highlighted {\r\n  background-color: var(--primary, #3b82f6) !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Opción seleccionada */\r\n.select2-container .select2-results__option--selected {\r\n  background-color: var(--primary, #3b82f6) !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Placeholder */\r\n.select2-container .select2-selection__placeholder {\r\n  color: var(--gray500, #6b7280) !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n/* Texto seleccionado */\r\n.select2-container .select2-selection__rendered {\r\n  color: var(--gray700, #374151) !important;\r\n  line-height: 1.4 !important;\r\n  padding-left: 0 !important;\r\n  padding-right: 2vh !important;\r\n}\r\n\r\n/* Search box en el dropdown */\r\n.select2-container .select2-search--dropdown {\r\n  padding: 1vh !important;\r\n}\r\n\r\n.select2-container .select2-search__field {\r\n  border-radius: 0.8vh !important;\r\n  border: 1px solid var(--gray300, #d1d5db) !important;\r\n  padding: 0.8vh !important;\r\n  font-size: 1.6vh !important;\r\n  font-family: 'Inter', sans-serif !important;\r\n  outline: none !important;\r\n}\r\n\r\n.select2-container .select2-search__field:focus {\r\n  border-color: var(--primary, #3b82f6) !important;\r\n  box-shadow: 0 0 0 0.1vh rgba(59, 130, 246, 0.2) !important;\r\n}\r\n\r\n/* Asegurar que el contenedor no tenga estilos por defecto */\r\n.select2-container {\r\n  display: block !important;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  border: none !important;\r\n  background: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
